import { useQuery, UseQueryResult } from 'react-query';
import { Location } from 'types';
import { client } from 'utils/api-client';

function useLocation(locationId: string | undefined): UseQueryResult<{ data: Location }> {
  return useQuery(['location', locationId], () => client.get(`locations/${locationId}/`), {
    enabled: !!locationId,
  });
}

export default useLocation;
